<template>
    <va-edit-layout>
        <CouponPaymentEventCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></CouponPaymentEventCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
